"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgToilet32 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 32, height: 32, viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 0h32v32H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M22.676 18.897V25m-2.647-6.103V25M24 18.897v-6.974h-5.294v6.974m2.647-8.282c.73 0 1.323-.585 1.323-1.307 0-.723-.592-1.308-1.323-1.308s-1.324.585-1.324 1.308c0 .722.593 1.307 1.324 1.307Zm-10.147 8.282V25m2.647-6.103V25m2.206-6.103-1.255-3.72a1.308 1.308 0 0 1-.069-.417v-2.837h-4.411v2.837c0 .142-.024.283-.07.418L9 18.898m3.53-8.283c.73 0 1.323-.585 1.323-1.307 0-.723-.593-1.308-1.324-1.308-.73 0-1.323.585-1.323 1.308 0 .722.592 1.307 1.323 1.307Z", stroke: "currentColor" })] })) }))); };
exports.default = SvgToilet32;
